<app-carousel [enableControlsOffset]="!isMobile">
  <ng-template carouselItem="1">
    <mat-card class="mat-card-c">
      <ng-container *ngTemplateOutlet="descriptionTemplate"></ng-container>
    </mat-card>
  </ng-template>

  <ng-template carouselItem="2" *ngIf="workOrderDetails.workOrderId">
    <mat-card class="mat-card-c">
      <h2 style="display: flex; justify-content: center">
        <strong>ANEXOS</strong>
      </h2>
      <div>
        <h3
          *ngIf="!imageSrc && !imageSrc2 && !imageSrc3"
          style="display: flex; justify-content: center"
        >
          No hay imágenes asociadas a esta orden de trabajo
        </h3>
      </div>
      <div class="containerPhotos">
        <div class="photo" *ngIf="imageSrc">
          <img
            class="mat-elevation-z8"
            src="{{ imageSrc }}"
            [ngStyle]="sizePicture"
          />
        </div>
        <div class="photo" *ngIf="imageSrc2">
          <img
            class="mat-elevation-z8"
            src="{{ imageSrc2 }}"
            [ngStyle]="sizePicture"
          />
        </div>
        <div class="photo" *ngIf="imageSrc3">
          <img
            class="mat-elevation-z8"
            src="{{ imageSrc3 }}"
            [ngStyle]="sizePicture"
          />
        </div>
      </div>
    </mat-card>
  </ng-template>

  <ng-template carouselItem="3" *ngIf="inventoryModule && resources.length > 0">
    <mat-card class="mat-card-c">
      <h2 style="display: flex; justify-content: center">
        <strong>RECURSOS</strong>
      </h2>
      <data-table
        [title]="''"
        [columns]="columnsResouces"
        [configuration]="configurationResouces"
        [url]="urlGetTableResources"
        [params]="paramsResources"
        (internalData)="dataResources($event)"
      >
      </data-table>
    </mat-card>
  </ng-template>

  <ng-template carouselItem="4">
    <mat-card class="mat-card-c">
      <data-table
        [title]="titleC"
        [columns]="columnsComments"
        [configuration]="configurationComments"
        [reloadTable]="reloadComments"
        [url]="EndpointDictionary.WorkOrder.COMMENTS.TABLE"
        [params]="paramsComments"
        (fileIconClick)="onFileIconClick($event)"
      >
      </data-table>
    </mat-card>
  </ng-template>
</app-carousel>

<!-- <ng-template #matDescription>
  <mat-card class="mat-card-c">
    <ng-container *ngTemplateOutlet="descriptionTemplate"></ng-container>
  </mat-card>
</ng-template> -->

<ng-template #descriptionTemplate>
  <h2>
    <strong>Equipo: {{ data.code }} </strong>
  </h2>
  <h3>Número de orden: {{ data.consecutive }}</h3>
  <h3>Odómetro/Horómetro: {{ data.odometer | number : "1.0-0" }}</h3>
  <h3>Referencia Factura: {{ data.invoiceReference }}</h3>
  <h3>Tipo de mantenimiento: {{ data.maintenanceType }}</h3>
  <h3>Tiempo estimado: {{ data.estimatedTime }} horas</h3>
  <h3>Tiempo total: {{ data.finalTime }} horas</h3>
  <h3>Descripción: {{ data.description }}</h3>
  <h3>Responsable: {{ data.responsible }}</h3>
  <h3>Fecha ejecucion: {{ data.executionDate }}</h3>
  <h3 *ngIf="data.resources">Recursos: {{ data.resources }}</h3>
  <h3>
    Costo Mantenimiento:
    {{
      (data.finalCost == null || data.finalCost == 0
        ? data.cost
        : data.finalCost
      ) | number : "1.0-0"
    }}
  </h3>
  <h3 *ngIf="inventoryModule">
    Costo Recursos: {{ totalCostItems | number : "1.0-0" }}
  </h3>
  <h3 *ngIf="inventoryModule">
    Costo Total:
    {{
      totalCostItems +
        (data.finalCost == null || data.finalCost == 0
          ? (data.cost ? +data.cost : 0)
          : data.finalCost) | number : "1.0-0"
    }}
  </h3>
  <h3>Observaciones: {{ data.observations }}</h3>
  <hr />
  <h2>Autorizó: {{ data.authorizesName }}</h2>
  <hr />
  <h3 *ngIf="bodyUsuarios.length > 0">
    {{
    workOrderDetails.workOrderId
      ? 'El Mtto lo realizó un: ' + bodyUsuarios[0].responsibleType
      : 'El Mtto lo realizará un: ' + bodyUsuarios[0].responsibleType
  }}
  </h3>
  <div *ngFor="let item of bodyUsuarios">
    <h3>Encargado: {{ item.name }}</h3>
  </div>
</ng-template>
